import { h } from 'preact'
import { StateUpdater } from 'preact/hooks'
import { i18n } from 'i18n/i18n'

import { CurrencyValueForm } from 'models/apps'

import { CalculatorCurrencyInput } from 'common-modules/calculator-currency-input'
import { CalculatorCurrencySelect } from 'common-modules/selects/calculator-currency-select'

interface CalculatorCurrencyInputWithSelectProps {
  value: CurrencyValueForm
  setValue: StateUpdater<CurrencyValueForm>
  isBelowMinimalAmount?: boolean
  debounceTime: number
  id?: string
  isBaseCurrencyComponent: boolean
  baseCurrency: string
  counterCurrency: string
  handleSetBaseCurrency: (currency: string) => void
  handleSetCounterCurrency: (currency: string) => void
  fixedCurrencyList: string[]
  isDarkMode?: boolean
  disableSwapOnCollision?: boolean
}

const getCurrencyName = (currency: string): string => `${i18n(`currencies.${currency}`)}`

export const CalculatorCurrencyInputWithSelect = ({
  value,
  setValue,
  isBelowMinimalAmount,
  debounceTime,
  id,
  isBaseCurrencyComponent,
  baseCurrency,
  counterCurrency,
  handleSetBaseCurrency,
  handleSetCounterCurrency,
  fixedCurrencyList,
  isDarkMode,
  disableSwapOnCollision,
}: CalculatorCurrencyInputWithSelectProps) => (
  <div className="preact-currency-input-with-select">
    <CalculatorCurrencyInput
      value={value}
      setValue={setValue}
      isBelowMinimalAmount={isBelowMinimalAmount}
      debounceTime={debounceTime}
      id={id}
    />
    <CalculatorCurrencySelect
      isBaseCurrencyComponent={isBaseCurrencyComponent}
      baseCurrency={baseCurrency}
      counterCurrency={counterCurrency}
      handleSetBaseCurrency={handleSetBaseCurrency}
      handleSetCounterCurrency={handleSetCounterCurrency}
      fixedCurrencyList={fixedCurrencyList}
      isDarkMode={isDarkMode}
      isSearchable={true}
      getOptionSubLabel={getCurrencyName}
      disableSwapOnCollision={disableSwapOnCollision}
    />
  </div>
)
